import { PropsWithChildren } from 'react'

import PageLayout from './PageLayout'

export default ({ children }: PropsWithChildren) => (
  <PageLayout>{children}</PageLayout>
)
